import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectExportedDevice, selectUpdatedExportDevice } from "src/app/store/user-file/user-file.selector";
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { ExportInfo } from "src/app/model/export";

@Component({
	templateUrl: './export-dialog.component.html',
})

export class ExportDeviceDialogComponent implements OnInit, OnDestroy {
	// filesForm: FormGroup;

	exportForm: FormGroup;

	update$: Observable<boolean | undefined>;
	updateSub: Subscription;

	export$: Observable<boolean | undefined>;
	exportSub: Subscription;

	exportInfo: ExportInfo;
	update: boolean;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.exportInfo !== undefined) {
			this.exportInfo = config.data.exportInfo;
			this.update = true;
		} else {
			this.exportInfo = new ExportInfo('', '');
			this.update = false;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.updateSub?.unsubscribe();
		this.exportSub?.unsubscribe();
	}

	initSelectors(): void {
		this.export$ = this.store.select(selectExportedDevice);
		this.update$ = this.store.select(selectUpdatedExportDevice);
	}

	buildForm(): void {
		this.exportForm = new FormGroup({
			'name': new FormControl(this.exportInfo.Name, [Validators.required, Validators.minLength(5)]),
			//'description': new FormControl(this.exportInfo.Description, [Validators.required, Validators.minLength(5)]),
		});
	}

	subscribeAll(): void {
		this.updateSub = this.update$?.subscribe(
			(res) => {
				if (res) {
					this.closeDialog();
				}
			}
		);
		this.exportSub = this.export$?.pipe(filter(res => !!res)).subscribe(
			(res) => {
				if (res) {
					this.closeDialog();
				}
			}
		);
	}

	get f(): any {
		return this.exportForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.exportForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.exportForm.get(key).errors;
			if (controlErrors != null) {
				/*Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});*/
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const exportInfo = new ExportInfo(this.exportForm.value.name, '');
		if (this.update) {
			this.store.dispatch(UserFileActions.updateExportDevice({ exportId: this.exportInfo.Id, exportInfo: exportInfo }));
		} else {
			exportInfo.Contents = [];
			exportInfo.Backup = false;
			this.store.dispatch(UserFileActions.exportDevice({ exportInfo }));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: ExportDeviceDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: ExportDeviceDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}